import { Row, Col } from 'react-bootstrap';
import type { CSSProperties } from 'react';
import type { TeamSessionSummary } from '../types/api.types';
import { TEAM_COLORS } from '../constants/teamColors';
import { parsePoints, calculateSessionTotals } from '../utils/teamCompetition';

interface TeamCompetitionSesionResultTableProps {
  results: TeamSessionSummary[];
}

export default function TeamCompetitionSesionResultTable({ results }: TeamCompetitionSesionResultTableProps) {
  if (!results || results.length === 0) {
    return <p>No results</p>;
  }

  const sessionRows = results.map((session) => (
    <tr key={session.sessionNum}>
      <td>{`${session.sessionNum} (Day ${session.day})`}</td>
      <td>{session.formatVariation ? `${session.format} - ${session.formatVariation}` : session.format}</td>
      <td style={{ textAlign: 'center' }}>{parsePoints(session.teamAPoints)}</td>
      <td style={{ textAlign: 'center' }}>{parsePoints(session.teamBPoints)}</td>
    </tr>
  ));

  const total = calculateSessionTotals(results);

  const styleUSA: CSSProperties = { textAlign: 'center', color: TEAM_COLORS.USA.hex };
  const styleEUR: CSSProperties = { textAlign: 'center', color: TEAM_COLORS.EUR.hex };

  const styleTeamA = results[0].teamA === 'USA' ? styleUSA : styleEUR;
  const styleTeamB = results[0].teamB === 'USA' ? styleUSA : styleEUR;

  return (
    <Row>
      <Col md={12}>
        <table className="table">
          <thead>
            <tr>
              <th>Session</th>
              <th>Format</th>
              <th style={styleTeamA}>{results[0].teamA}</th>
              <th style={styleTeamB}>{results[0].teamB}</th>
            </tr>
          </thead>
          <tbody>{sessionRows}</tbody>
          <tfoot>
            <tr style={{ fontWeight: 'bold' }}>
              <td>Total</td>
              <td />
              <td style={{ textAlign: 'center' }}>{total.teamAPoints}</td>
              <td style={{ textAlign: 'center' }}>{total.teamBPoints}</td>
            </tr>
          </tfoot>
        </table>
      </Col>
    </Row>
  );
}
